import { MaintenanceWindowsDeleteDialogGzDataProvider } from '../dataProvider/MaintenanceWindowsDeleteDialogGzDataProvider';
import { BaseWebComponentDataProviderFactory } from '../../../framework/BaseWebComponentDataProviderFactory';
import { API_TYPE_GZ } from '../../../webcomponents.constants';

export class MaintenanceWindowsDeleteDialogDataProviderFactory extends BaseWebComponentDataProviderFactory {
  constructor() {
    super();
    this.map.set(API_TYPE_GZ, MaintenanceWindowsDeleteDialogGzDataProvider);
  }
}
